<template>
  <div>
    <div
      class="bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8"
    >
      <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
          {{ title }}
        </h2>
      </div>

      <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <ErrorMessage v-if="error" :error="error" />
          <SuccessMessage v-if="success" :msg="success" />
          <form @submit.prevent="submit" class="space-y-6">

            <div>
                <input
                  v-model="form.email"
                  id="email"
                  name="email"
                  type="hidden"
                />
                <input
                  v-model="form.token"
                  id="token"
                  name="token"
                  type="hidden"
                />
            </div>

            <div>
              <label
                for="pass1"
                class="block text-sm font-medium text-gray-700"
              >
                Задайте новый пароль:
              </label>
              <div class="mt-1">
                <input
                  v-model="form.pass1"
                  id="pass1"
                  name="pass1"
                  type="password"
                  required
                  class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
              </div>
            </div>

            <div>
              <label
                for="pass2"
                class="block text-sm font-medium text-gray-700"
              >
                И ещё раз:
              </label>
              <div class="mt-1">
                <input
                  v-model="form.pass2"
                  id="pass2"
                  name="pass2"
                  type="password"
                  required
                  class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
              </div>
            </div>

            <div>
              <button
                :disabled="workInProgress"
                type="submit"
                class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Отправить
              </button>
            </div>
          </form>

        </div>
      </div>
    </div>

  </div>
</template>

<script>


import ErrorMessage from "@/components/ErrorMessage";
import SuccessMessage from "../components/SuccessMessage.vue";
import axios from "axios";

export default {
  name: "signin",
  components: {
    ErrorMessage,
    SuccessMessage,
  },
  data() {
    return {
      form: {
        email: "",
        token: "",
        pass1: "",
        pass2: "",
      },
      workInProgress: false,
      error: "",
      success: "",
      title: "Сброс пароля",
    };
  },
mounted() {
    this.form.email = this.$route.query.email
    this.form.token = this.$route.query.token
},
  methods: {
    async submit() {
        this.error = "";
        this.success = "";
        if (this.form.pass1 != this.form.pass2) {
            this.error = 'Пароли не совпадают.'
            return
        }
        try {
          this.workInProgress = true
          await axios.post(
              "user/resetpassword", 
              Object.assign(this.form)
          );
          this.workInProgress = false
          this.success = 'Пароль изменён!'
        } catch (e) {
          this.workInProgress = false
          if (e.response.status == 520) {
            this.error = e.response.data.error;
          } else {
            this.error = "Неизвестная ошибка.";
          }
        }

    },
  },
};
</script>